// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullRegattaResultTableRace,
} from 'common.data';

// Global Components
import * as React from 'react';

// Helpers
import moment from 'moment';
import {
  regattaResultTableRaceTypeLabel,
} from 'common.language';

// Types
type $OptionalProps = {
  data: $FullRegattaResultTableRace;
};

type $Props = $OptionalProps & $Translate;

type $State = {
  visible: boolean;
};

class RaceInfoButtonView extends React.Component<$Props, $State> {
  wrapperRef: React.RefObject<HTMLDivElement>;

  handleClickOutsideBind: (event) => void;

  constructor(props: $Props) {
    super(props);

    this.wrapperRef = React.createRef();

    this.handleClickOutsideBind = this.handleClickOutside.bind(this);

    this.state = {
      visible: false,
    };
  }

  componentDidMount(): void {
    document.addEventListener(
      'mousedown',
      this.handleClickOutsideBind,
    );
  }

  componentWillUnmount(): void {
    document.removeEventListener(
      'mousedown',
      this.handleClickOutsideBind,
    );
  }

  handleClickOutside(event): void {
    if (this.wrapperRef
      && this.wrapperRef.current
      && !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({
        visible: false,
      });
    }
  }

  renderCard() {
    const {
      data,
      t,
    } = this.props;

    const startDate: string = moment(
      `${data.Year}-${data.Month}-${data.Day} ${data.Hour}:${data.Minute}:${data.Second}`,
      'YYYY-MM-DD HH:mm:ss',
    ).format('YYYY-MM-DD HH:mm:ss');

    return (
      <div
        className={'card absolute z-10 w-48 left-0 right-0 p-2'}
        ref={this.wrapperRef}
      >
        <div className={'font-normal grid grid-cols-2 gap-2'}>
          <div className={'text-left col-span-2'}>
            <small className={'text-gray-600 uppercase'}>
              {t('Title')}
            </small>
            <div className={'text-color-standard'}>
              {data.Name}
            </div>
          </div>
          <div className={'text-left col-span-2'}>
            <small className={'text-gray-600 uppercase'}>
              {t('Start')}
            </small>
            <div className={'text-color-standard'}>
              {startDate}
            </div>
          </div>
          <div className={'text-left col-span-2'}>
            <small className={'text-gray-600 uppercase'}>
              {t('Calculation method')}
            </small>
            <div className={'text-color-standard'}>
              {regattaResultTableRaceTypeLabel[data.Type]}
            </div>
          </div>
          <div className={'text-left'}>
            <small className={'text-gray-600 uppercase'}>
              {t('Distance')}
            </small>
            <div className={'text-color-standard'}>
              {data.Distance ? `${data.Distance}NM` : '-'}
            </div>
          </div>
          <div className={'text-left'}>
            <small className={'text-gray-600 uppercase'}>
              {t('Coef.')}
            </small>
            <div className={'text-color-standard'}>
              {data.Coef}
            </div>
          </div>
        </div>
        <div className={'font-normal grid grid-cols-3 gap-3'}>
          <div className={'text-left'}>
            <small className={'text-gray-600 uppercase'}>
              {t('Course')}
            </small>
            <div className={'text-color-standard'}>
              {data.Course || '-'}
            </div>
          </div>
          <div className={'text-left'}>
            <small className={'text-gray-600 uppercase'}>
              {t('Twa')}
            </small>
            <div className={'text-color-standard'}>
              {data.Twa || '-'}
            </div>
          </div>
          <div className={'text-left'}>
            <small className={'text-gray-600 uppercase'}>
              {t('Tws')}
            </small>
            <div className={'text-color-standard'}>
              {data.Tws || '-'}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      t,
    } = this.props;
    const {
      visible,
    } = this.state;

    return (
      <>
        {visible === true && this.renderCard()}
        <button
          className={'RaceInfoButton btn btn_light btn_outlined p-1 ml-2 uppercase'}
          onClick={() => this.setState({
            visible: !visible,
          })}
          title={t('Race information')}
          type={'button'}
        >
          <em className={'la la-sms'} />
        </button>
      </>
    );
  }
}

export default RaceInfoButtonView;
